import React from 'react';

import MustachePrice from './MustachePrice';
import MustacheData from '../Data/MustacheData';

class MustachePrices extends React.Component {

    constructor() {
        super();
        this.state = {
            prices: MustacheData

        }
    }


    render() {

        const allItems = this.state.prices.map(item =>
            <MustachePrice
                key={item.id}
                text={item.text}
                price={item.price}
            />);


        return (

            <React.Fragment>
                {allItems}
            </React.Fragment>
        )
    }

}


export default MustachePrices;